const womenSizes = ["XS", "S", "M", "L", "XL"];
const numericSizes = ["34", "36", "38", "40", "42"];
const menSizes = ["S", "M", "L", "XL"];

const badgeLabels = {
  "new-in": "New in",
  "web-only": "Web Only",
  bestseller: "Bestseller",
};

const swatchColors = {
  "Blue Flowers": "#7696aa",
  Seafoam: "#abc3b7",
  Natural: "#d9d0bd",
  Sand: "#c9b79c",
  Terracotta: "#a85f47",
  Midnight: "#18374b",
  "Oat Stripe": "#d8cfbd",
  "Deep Sea Stripe": "#29495b",
  "Coral Stripe": "#d87967",
  "Sky Stripe": "#86a9bd",
  Forest: "#40594b",
  Ocean: "#326d89",
  "Golden Brown": "#a27645",
  Ecru: "#e6dfcd",
  Apricot: "#e3a37c",
  Navy: "#243b50",
  Marine: "#366c86",
  Sunflower: "#d6aa32",
  Rust: "#9b513b",
  "Blue Stripe": "#567d96",
  "Clay Stripe": "#a76e5e",
  Indigo: "#334b72",
  Ruby: "#913f49",
  Moss: "#69735a",
  Salt: "#e7e3d7",
  Clay: "#a87461",
  "Ocean Stripe": "#3d7288",
  "Kelp Stripe": "#536a55",
  Kelp: "#536a55",
  "Deep Sea": "#193e55",
  Olive: "#73734e",
  "Ecru & Navy": "#b9b4a9",
};

export const getColorHex = (color, fallback = "#8b918e") => swatchColors[color] || fallback;

const createProduct = (product) => {
  const image = `/img/products/${product.imageKey}.jpg`;
  const sizes = product.sizes || (product.gender === "Men" ? menSizes : womenSizes);
  const colors = product.colors || [product.colorName];

  return {
    ...product,
    image,
    images: [image],
    size: sizes,
    sizes,
    colors,
    colorOptions: colors.map((name) => ({ name, hex: getColorHex(name, product.colorHex) })),
    attributes: {
      material: product.material,
      fit: product.fit || "Regular fit",
      origin: product.origin || "Designed in Barcelona · Crafted in Portugal",
      care: product.care || "Cold gentle wash · Line dry",
      model:
        product.model ||
        (product.gender === "Men"
          ? "Model is 1.86m and wears size M"
          : "Model is 1.76m and wears size S"),
    },
    badges: product.tags.filter((tag) => badgeLabels[tag]).map((tag) => badgeLabels[tag]),
    rating: product.rating || 4.8,
    reviews: product.reviews || 86 + product.id * 3,
  };
};

const productData = [
  createProduct({
    id: 1,
    slug: "balandra-blue-flowers",
    imageKey: "01-balandra",
    name: "Balandra",
    colorName: "Blue Flowers",
    category: "Dresses",
    gender: "Women",
    price: 232,
    compareAt: 246,
    material: "100% LENZING™ ECOVERO™ viscose",
    description: "An easy midi dress with a softly defined waist and a hand-drawn floral rhythm inspired by clear Atlantic water.",
    features: ["V-neckline", "Midi length", "Side pockets", "Corozo nut buttons", "Vegan"],
    colorHex: "#7696aa",
    tags: ["new-in", "web-only", "pre-order", "featured", "women"],
    status: "Pre-order",
    rating: 4.9,
    reviews: 124,
  }),
  createProduct({
    id: 2,
    slug: "glen-seafoam",
    imageKey: "02-glen",
    name: "Glen",
    colorName: "Seafoam",
    category: "Knitwear",
    gender: "Women",
    price: 145,
    compareAt: 159,
    material: "70% organic cotton · 30% recycled cotton",
    fit: "Relaxed fit",
    description: "A tactile cardigan in a calm seafoam shade, knitted with a relaxed shape for cool evenings by the water.",
    features: ["Textured knit", "Dropped shoulder", "Ribbed edges", "Natural corozo buttons", "Vegan"],
    colors: ["Seafoam", "Natural"],
    colorHex: "#abc3b7",
    tags: ["new-in", "pre-order", "featured", "women"],
    status: "Pre-order",
  }),
  createProduct({
    id: 3,
    slug: "binlang-sand",
    imageKey: "03-binlang",
    name: "Binlang",
    colorName: "Sand",
    category: "Jumpsuits",
    gender: "Women",
    price: 159,
    compareAt: null,
    material: "100% European linen",
    fit: "Relaxed fit",
    description: "A softly tailored linen jumpsuit with a wide leg and adjustable waist, made for sun-warmed days.",
    features: ["Wide leg", "Adjustable waist", "Front patch pockets", "Breathable linen", "Vegan"],
    colorHex: "#c9b79c",
    tags: ["new-in", "web-only", "women"],
    status: "In stock",
  }),
  createProduct({
    id: 4,
    slug: "karri-dos-terracotta",
    imageKey: "04-karri-dos",
    name: "Karri Dos",
    colorName: "Terracotta",
    category: "Trousers",
    gender: "Women",
    price: 159,
    compareAt: 173,
    material: "54% linen · 46% organic cotton",
    fit: "Wide leg",
    sizes: numericSizes,
    model: "Model is 1.75m and wears size 36",
    description: "High-rise trousers with a fluid wide leg and a sunbaked terracotta tone that moves easily from coast to city.",
    features: ["High rise", "Front pleats", "Side pockets", "Corozo button", "Vegan"],
    colorHex: "#a85f47",
    tags: ["new-in", "pre-order", "women"],
    status: "Pre-order",
  }),
  createProduct({
    id: 5,
    slug: "soneva-midnight",
    imageKey: "05-soneva",
    name: "Soneva",
    colorName: "Midnight",
    category: "Dresses",
    gender: "Women",
    price: 231,
    compareAt: 246,
    material: "100% TENCEL™ lyocell",
    description: "A deep navy midi dress with clean lines, soft volume and a waist tie that adjusts to your silhouette.",
    features: ["Midi length", "Removable waist tie", "Side pockets", "Soft drape", "Vegan"],
    colorHex: "#18374b",
    tags: ["web-only", "pre-order", "featured", "women"],
    status: "Pre-order",
    rating: 4.9,
    reviews: 152,
  }),
  createProduct({
    id: 6,
    slug: "harakka-oat-stripe",
    imageKey: "06-harakka",
    name: "Harakka",
    colorName: "Oat Stripe",
    category: "Knitwear",
    gender: "Women",
    price: 130,
    compareAt: null,
    material: "100% organic cotton",
    fit: "Relaxed fit",
    description: "A soft striped knit that pairs an oat base with fine navy lines for an understated maritime character.",
    features: ["Fine gauge knit", "Boat neck", "Side splits", "Ribbed cuffs", "Vegan"],
    colors: ["Oat Stripe", "Deep Sea Stripe"],
    colorHex: "#d8cfbd",
    tags: ["web-only", "women"],
    status: "In stock",
  }),
  createProduct({
    id: 7,
    slug: "marianne-coral-stripe",
    imageKey: "07-marianne",
    name: "Marianne",
    colorName: "Coral Stripe",
    category: "Shirts",
    gender: "Women",
    price: 150,
    compareAt: 159,
    material: "100% European linen",
    fit: "Oversized fit",
    description: "A breathable linen shirt with coral pinstripes, a curved hem and an easy oversized proportion.",
    features: ["Dropped shoulder", "Curved hem", "Chest pocket", "Corozo buttons", "Vegan"],
    colors: ["Coral Stripe", "Sky Stripe", "Natural"],
    colorHex: "#d87967",
    tags: ["web-only", "pre-order", "women"],
    status: "Pre-order",
  }),
  createProduct({
    id: 8,
    slug: "formentera-forest",
    imageKey: "08-formentera",
    name: "Formentera",
    colorName: "Forest",
    category: "Dresses",
    gender: "Women",
    price: 231,
    compareAt: 275,
    material: "100% LENZING™ ECOVERO™ viscose",
    description: "A long forest-green shirt dress with a fluid silhouette, generous pockets and a softly gathered waist.",
    features: ["Maxi length", "Button front", "Elasticated waist", "Side pockets", "Vegan"],
    colors: ["Forest", "Ocean", "Golden Brown"],
    colorHex: "#40594b",
    tags: ["sale", "web-only", "featured", "women"],
    status: "Sale",
    rating: 4.9,
    reviews: 205,
  }),
  createProduct({
    id: 9,
    slug: "theaki-ecru",
    imageKey: "09-theaki",
    name: "Theaki",
    colorName: "Ecru",
    category: "Knitwear",
    gender: "Women",
    price: 175,
    compareAt: null,
    material: "80% organic cotton · 20% recycled cotton",
    fit: "Boxy fit",
    description: "A sculptural ecru knit vest with hand-feel texture, designed to layer across shifting seasons.",
    features: ["Textured stitch", "Wide ribbed hem", "Side splits", "Layering weight", "Vegan"],
    colorHex: "#e6dfcd",
    tags: ["web-only", "women"],
    status: "In stock",
  }),
  createProduct({
    id: 10,
    slug: "kalaoa-apricot",
    imageKey: "10-kalaoa",
    name: "Kalaoa",
    colorName: "Apricot",
    category: "Sweatshirts",
    gender: "Women",
    price: 115,
    compareAt: 130,
    material: "100% organic cotton",
    fit: "Relaxed fit",
    description: "A softly brushed organic cotton sweatshirt in a warm apricot shade with a clean, everyday cut.",
    features: ["Brushed interior", "Raglan sleeves", "Ribbed trims", "Garment dyed", "Vegan"],
    colors: ["Apricot", "Seafoam", "Navy"],
    colorHex: "#d9a076",
    tags: ["web-only", "pre-order", "featured", "women"],
    status: "Pre-order",
  }),
  createProduct({
    id: 11,
    slug: "pom-pom-marine",
    imageKey: "11-pom-pom",
    name: "Pom Pom",
    colorName: "Marine",
    category: "Knitwear",
    gender: "Women",
    price: 159,
    compareAt: 173,
    material: "60% recycled wool · 40% recycled polyamide",
    description: "A compact marine cardigan with subtle volume at the sleeve and a neat waist-skimming finish.",
    features: ["Balloon sleeve", "Ribbed cuffs", "Corozo buttons", "Warm midweight knit", "Recycled fibres"],
    colorHex: "#223b50",
    tags: ["new-in", "pre-order", "women"],
    status: "Pre-order",
  }),
  createProduct({
    id: 12,
    slug: "makawao-sunflower",
    imageKey: "12-makawao",
    name: "Makawao",
    colorName: "Sunflower",
    category: "Tops",
    gender: "Women",
    price: 82,
    compareAt: 101,
    material: "100% organic cotton",
    description: "A sun-yellow organic cotton tee with a soft hand feel and a proportion that sits just above the hip.",
    features: ["Crew neck", "Soft jersey", "Twin-needle hem", "Garment dyed", "Vegan"],
    colors: ["Sunflower", "Rust"],
    colorHex: "#d8ad38",
    tags: ["sale", "web-only", "women"],
    status: "Sale",
  }),
  createProduct({
    id: 13,
    slug: "poivre-blue-stripe",
    imageKey: "13-poivre",
    name: "Poivre",
    colorName: "Blue Stripe",
    category: "Trousers",
    gender: "Women",
    price: 173,
    compareAt: 188,
    material: "55% linen · 45% organic cotton",
    fit: "Wide leg",
    description: "Airy blue-striped trousers with a high waist, tailored front and generous leg for effortless movement.",
    features: ["High rise", "Elastic back waist", "Side pockets", "Full length", "Vegan"],
    colors: ["Blue Stripe", "Clay Stripe"],
    colorHex: "#7294a8",
    tags: ["web-only", "pre-order", "women"],
    status: "Pre-order",
  }),
  createProduct({
    id: 14,
    slug: "grassholm-indigo",
    imageKey: "14-grassholm",
    name: "Grassholm",
    colorName: "Indigo",
    category: "Dresses",
    gender: "Women",
    price: 217,
    compareAt: 246,
    material: "100% organic cotton denim",
    description: "A structured indigo denim dress with a long buttoned line and workwear-inspired patch pockets.",
    features: ["Midi length", "Front buttons", "Patch pockets", "Contrast topstitching", "Vegan"],
    colorHex: "#304c63",
    tags: ["sale", "featured", "women"],
    status: "Sale",
    rating: 4.9,
    reviews: 167,
  }),
  createProduct({
    id: 15,
    slug: "hauula-ruby",
    imageKey: "15-hauula",
    name: "Hauula",
    colorName: "Ruby",
    category: "Tops",
    gender: "Women",
    price: 58,
    compareAt: 87,
    material: "100% European linen",
    description: "A clean sleeveless linen top in mineral ruby, cut with a softly rounded neck and side vents.",
    features: ["Sleeveless", "Side vents", "Back keyhole", "Breathable linen", "Vegan"],
    sizes: ["S", "M", "L", "XL"],
    colorHex: "#934c47",
    tags: ["sale", "women"],
    status: "Sale",
  }),
  createProduct({
    id: 16,
    slug: "bagaat-moss",
    imageKey: "16-bagaat",
    name: "Bagaat",
    colorName: "Moss",
    category: "Jackets",
    gender: "Men",
    price: 146,
    compareAt: null,
    material: "100% organic cotton corduroy",
    fit: "Relaxed fit",
    description: "A moss corduroy overshirt that combines the ease of a shirt with the weight and pockets of a light jacket.",
    features: ["Wide wale corduroy", "Two chest pockets", "Corozo buttons", "Curved hem", "Vegan"],
    colors: ["Moss", "Sand", "Navy"],
    colorHex: "#5e694c",
    tags: ["web-only", "featured", "men"],
    status: "In stock",
    rating: 4.8,
    reviews: 131,
  }),
  createProduct({
    id: 17,
    slug: "mljet-sky-stripe",
    imageKey: "17-mljet",
    name: "Mljet",
    colorName: "Sky Stripe",
    category: "Shirts",
    gender: "Men",
    price: 175,
    compareAt: null,
    material: "100% European linen",
    fit: "Relaxed fit",
    description: "A breezy sky-striped linen shirt with a relaxed collar and an easy shape for long coastal days.",
    features: ["Open collar", "Chest pocket", "Corozo buttons", "Straight hem", "Vegan"],
    colors: ["Sky Stripe", "Coral Stripe"],
    colorHex: "#9bb8c8",
    tags: ["featured", "men"],
    status: "In stock",
  }),
  createProduct({
    id: 18,
    slug: "organic-cotton-tee-salt",
    imageKey: "18-organic-tee",
    name: "The Organic Cotton Tee",
    colorName: "Salt",
    category: "T-Shirts",
    gender: "Men",
    price: 58,
    compareAt: 67,
    material: "100% organic cotton",
    description: "Our essential tee in soft salt-white organic jersey, shaped for everyday comfort and lasting wear.",
    features: ["Midweight jersey", "Crew neck", "Reinforced shoulder", "Garment washed", "Vegan"],
    colors: ["Salt", "Navy", "Clay"],
    colorHex: "#ece7d8",
    tags: ["pre-order", "bestseller", "men"],
    status: "Pre-order",
    rating: 4.9,
    reviews: 362,
  }),
  createProduct({
    id: 19,
    slug: "qalito-ocean-stripe",
    imageKey: "19-qalito",
    name: "Qalito",
    colorName: "Ocean Stripe",
    category: "T-Shirts",
    gender: "Men",
    price: 76,
    compareAt: null,
    material: "100% organic cotton",
    fit: "Boxy fit",
    description: "A substantial ocean-striped tee with a dry organic cotton handle and an easy boxy silhouette.",
    features: ["Yarn-dyed stripe", "Crew neck", "Side vents", "Midweight jersey", "Vegan"],
    colors: ["Ocean Stripe", "Kelp Stripe", "Clay Stripe"],
    colorHex: "#47778c",
    tags: ["web-only", "men"],
    status: "In stock",
  }),
  createProduct({
    id: 20,
    slug: "saint-pierre-clay",
    imageKey: "20-saint-pierre",
    name: "Saint Pierre",
    colorName: "Clay",
    category: "T-Shirts",
    gender: "Men",
    price: 58,
    compareAt: 81,
    material: "100% organic cotton",
    description: "A clay-red henley tee in a softly textured organic jersey, finished with low-impact corozo buttons.",
    features: ["Henley neckline", "Corozo buttons", "Textured jersey", "Garment dyed", "Vegan"],
    colors: ["Clay", "Kelp"],
    colorHex: "#a05b47",
    tags: ["new-in", "sale", "men"],
    status: "Sale",
  }),
  createProduct({
    id: 21,
    slug: "offshore-deep-sea",
    imageKey: "21-offshore",
    name: "Offshore",
    colorName: "Deep Sea",
    category: "Shirts",
    gender: "Men",
    price: 58,
    compareAt: 87,
    material: "100% organic cotton",
    fit: "Relaxed fit",
    description: "A deep-sea short-sleeve shirt with a relaxed camp collar and a clean, understated surface.",
    features: ["Camp collar", "Chest pocket", "Corozo buttons", "Straight hem", "Vegan"],
    colorHex: "#203a4d",
    tags: ["sale", "men"],
    status: "Sale",
  }),
  createProduct({
    id: 22,
    slug: "kabak-olive",
    imageKey: "22-kabak",
    name: "Kabak",
    colorName: "Olive",
    category: "Jackets",
    gender: "Men",
    price: 146,
    compareAt: null,
    material: "100% organic cotton twill",
    description: "A light olive field jacket with practical patch pockets and a soft washed finish that improves with wear.",
    features: ["Four patch pockets", "Internal drawcord", "Corozo buttons", "Garment washed", "Vegan"],
    colors: ["Olive", "Navy"],
    colorHex: "#666f4b",
    tags: ["featured", "men"],
    status: "In stock",
  }),
  createProduct({
    id: 23,
    slug: "trinity-navy",
    imageKey: "23-trinity",
    name: "Trinity",
    colorName: "Navy",
    category: "Knitwear",
    gender: "Men",
    price: 205,
    compareAt: null,
    material: "100% organic cotton",
    description: "A substantial navy organic cotton knit with a textured stitch and refined ribbing at the neck and cuffs.",
    features: ["Textured knit", "Raglan shoulder", "Ribbed edges", "Portuguese yarn", "Vegan"],
    colors: ["Navy", "Natural"],
    colorHex: "#263c50",
    tags: ["featured", "men"],
    status: "In stock",
    rating: 4.9,
    reviews: 108,
  }),
  createProduct({
    id: 24,
    slug: "george-bay-ecru-navy",
    imageKey: "24-george-bay",
    name: "George Bay",
    colorName: "Ecru & Navy",
    category: "Knitwear",
    gender: "Men",
    price: 87,
    compareAt: 96,
    material: "100% organic cotton",
    description: "A knitted polo in warm ecru with a deep navy collar, balancing retro sport detail with a clean modern fit.",
    features: ["Contrast collar", "Fine gauge knit", "Ribbed hem", "Corozo buttons", "Vegan"],
    colorHex: "#ded6c4",
    tags: ["new-in", "pre-order", "men"],
    status: "Pre-order",
  }),
];

export const productCategories = [...new Set(productData.map((product) => product.category))];

export default productData;
